import { render, staticRenderFns } from "./DeliveryPayment.vue?vue&type=template&id=94369e56"
import script from "./DeliveryPayment.vue?vue&type=script&lang=js"
export * from "./DeliveryPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports